import styled from 'styled-components'

import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { Box } from '@ucheba/ui/components/Box/touch'

import RestartIcon from '@ucheba/ui/icons/icon__restart.svg'

import { Text } from '@ucheba/ui/components/Text/desktop'

import { ListItem } from '@ucheba/ui/components/List/desktop'

export const ProgramsBox = styled(Box)`
  padding-bottom: 0;
  padding-top: 24px;
`

export const AnotherProgramsBox = styled(Box)`
  padding-top: 24px;
`

export const Divider = styled.div`
  display: none;
  margin-top: 32px;

  border-bottom: 1px solid ${sv.color.gray9};
`
export const ListItemStyled = styled(ListItem)`
  &:not(:last-of-type) {
    ${Divider} {
      display: block;
    }
  }
`

interface IContainerProps {
  mainColor: string
  textColor: string
}

export const Container = styled.div<IContainerProps>`
  padding: 16px 16px 8px;

  border-radius: 8px;
  background: ${({ mainColor }) => sv.color[mainColor]};
  color: ${({ textColor }) => sv.color[textColor]};
`

export const HeaderBox = styled(Box)`
  padding-top: 22px;
`

export const ProgrammsBox = styled(Box)`
  padding-top: 24px;
  padding-bottom: 0;
`

export const ProgrammsBoxAnotherInstitutions = styled(Box)`
  padding-top: 32px;
  padding-bottom: 32px;
`

export const ContainerTouch = styled(Container)`
  margin: 0 auto;
  padding: 8px 8px 8px 12px;
`

interface IRestartIconStyledProps {
  color: string
}

export const RestartIconButton = styled(RestartIcon)<IRestartIconStyledProps>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;

  cursor: pointer;
  color: ${({ color }) => sv.color[color]};
`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 12px;

  border-bottom: 1px solid ${sv.color.gray5};
`

export const TextStyled = styled(Text)`
  line-height: 18px;
`

export const RestartIconStyled = styled(RestartIcon)`
  width: 24px;
  height: 24px;
`

export const Buttons = styled.div`
  display: flex;
  column-gap: 8px;
`

export const LoaderWrapper = styled.div`
  height: calc(100vh - 280px);
  display: flex;
  align-items: center;
`

export const ButtonsTouch = styled(Buttons)`
  flex-direction: column;
  row-gap: 16px;
`

export const Raiting = styled.div`
  display: flex;
  column-gap: 4px;

  svg {
    width: 18px;
    height: 18px;
    margin: 2px 0 4px 0;

    color: ${sv.color.orange};
  }
`

export const Subject = styled.span`
  font-size: 14px;
  line-height: 18px;
  color: ${sv.color.black};

  &:first-letter {
    text-transform: uppercase;
  }
`

export const Block = styled.div`
  display: flex;
  column-gap: 4px;
`

interface IChipsStyledProps {
  textColor: string
}

export const ChipsStyled = styled(Chips)<IChipsStyledProps>`
  color: ${({ textColor }) => textColor};
`
